<template>
  <v-container id="advantages" bg="l">
    <div class="advantages" style="min-height: 600px;">
      <v-headline :level="2" class="uppercase"
        >{{ dic.sectionAdvantages.title }} {{ dic.brand }}</v-headline
      >

      <div class="advantages-pagination text-md">
        <v-tab
          v-for="{ id, caption, form } of advantages"
          :key="id"
          :form="form"
          :isActive="form === activeForm"
          >{{ caption }}</v-tab
        >
      </div>

      <v-board
        v-for="{ id, list, form } of advantages"
        :key="id"
        :items="list"
        v-show="form === activeForm"
      />

      <v-button class="button text-sm" type="R" color="Y">
        <v-link anchor="#form">
          {{ dic.fastRegistration }}
        </v-link>
      </v-button>
    </div>
  </v-container>
</template>

<script>
import VContainer from '@/components/ui/VContainer'
import VHeadline from '@/components/ui/VHeadline'
import VBoard from '@/components/ui/VBoard'
import VTab from '@/components/ui/VTab'
import VButton from '@/components/ui/VButton'
import VLink from '@/components/ui/VLink'

import { mapState } from 'vuex'

export default {
  components: {
    VContainer,
    VHeadline,
    VBoard,
    VTab,
    VButton,
    VLink,
  },

  computed: {
    ...mapState('forms', ['activeForm']),

    ...mapState('advantages', {
      advantages: (state) => state.data,
    }),
   currentLang() {
      //this need for wake up store listner 
      return this.$store.state.main.currentLang
    },
    dic() {
      this.currentLang //this need for wake up store listner 
      return this.$store.state.main.dic
    },
  },
}
</script>

<style scoped lang="scss">
.advantages {
  width: 100%;
  text-align: center;
  box-sizing: border-box;

  &-pagination {
    display: flex;

    width: 100%;
    font-weight: 500;
    justify-content: center;
    box-sizing: border-box;
    padding: 35px 20px;
  }
}

.button {
  margin: 30px 0;
}
</style>

<style lang="scss" scoped>
@media (max-width: 375px) {
}
</style>
